import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-vue-logo",
  "use": "icon-vue-logo-usage",
  "viewBox": "0 -17.5 256 256",
  "content": "<symbol viewBox=\"0 -17.5 256 256\" xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMinYMin meet\" id=\"icon-vue-logo\"><path d=\"M204.8 0H256L128 220.8 0 0h97.92L128 51.2 157.44 0h47.36z\" fill=\"#41B883\" /><path d=\"M0 0l128 220.8L256 0h-51.2L128 132.48 50.56 0H0z\" fill=\"#41B883\" /><path d=\"M50.56 0L128 133.12 204.8 0h-47.36L128 51.2 97.92 0H50.56z\" fill=\"#35495E\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/vue-logo.svg
// module id = rL67
// module chunks = 21